import { keymap } from 'prosemirror-keymap';
import { Schema } from 'prosemirror-model';
import { EditorView } from 'prosemirror-view';

import { EditorButton, RtPMPlugin } from '../../../editor/types';
import { MarkService, toggleMark } from '../../../helpers/mark-base';
import { DEFAULT_KEYMAP_INPUTRULE_PRIORITY } from '../../../helpers/utils';
import { EmSchema } from './italic-mark';

export class ItalicService<S extends EmSchema> extends MarkService<S> {}

export class ItalicPlugin implements RtPMPlugin {
  public api: { italicService: ItalicService<Schema> };
  public buttons = {
    toggleItalic: <EditorButton>{
      icon: 'format-ital',
      isActive: (...args) => this.api.italicService.isActive(...args),
      run: (state, dispatch) => {
        this.api.italicService.toggle(state, dispatch);
        this.editorView.focus();
      },
    },
  };

  private editorView: EditorView<EmSchema>;

  public beforeEditorInit(schema: EmSchema) {
    this.api = {
      italicService: new ItalicService(schema.marks.em),
    };
  }

  public afterEditorInit(editorView: EditorView<EmSchema>) {
    this.editorView = editorView;
  }

  public getNativeEditorPlugins(schema: EmSchema) {
    return [
      { priority: DEFAULT_KEYMAP_INPUTRULE_PRIORITY, plugin: keymap(this.getKeyBindings(schema)) },
    ];
  }

  private getKeyBindings(schema: EmSchema) {
    return {
      'Mod-I': toggleMark(schema.marks.em),
      'Mod-i': toggleMark(schema.marks.em),
    };
  }
}
